import script from "./HeaderNav.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderNav.vue?vue&type=script&setup=true&lang=js"

import "./HeaderNav.vue?vue&type=style&index=0&id=2ef87bf9&lang=scss"

const __exports__ = script;

export default __exports__